
import { Mixins, Component, PropSync, Watch, Prop, Ref } from 'vue-property-decorator'
import { getProductClassifyList, getUpdateBatchPage, updateBatchStatus } from "@/api/prescriptionDb";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import ETable from '@/components/ETable.vue';
import { computed } from 'vue';

@Component({
  components: { ETable }
})
export default class productBatchEdit extends Mixins(loading, tablePagination, Resize) {
  @PropSync("visible", { default: false }) batchEditDialogVisible !: boolean;
  @Prop({ default: 0 }) merchantId !: number;
  @Ref("tableRef") TableRef !: any;

  columns = [
    { label: " ", type: "selection", reserveSelection: true, rowKey: "id", width: 55, fix: "left" },
    { label: "产品名称", prop: "name", minWidth: "120" },
    { label: "产品分类", prop: "productClassify", minWidth: "120" },
    { label: "产品类型", prop: "productType", minWidth: "120" },
    { label: "产品状态", prop: "", minWidth: "100", formatter: (row: any) => this.getProductStatusDesc(row.status) },
  ]

  dataSource = []
  itemTotal = 0;

  queryForm = {
    merchantId: this.merchantId,
    productType: "",
    productClassify: "",
    status: "",
    name: "",
  };

  batchDisabled = true;
  selectionList = [];

  mounted() {
    this.getData();
  }

  productTypeOptions = [
    { id: 1, name: "项目产品库" },
    { id: 2, name: "居家产品库" },
    { id: 3, name: "其他库" }
  ];
  productStatusOptions = [
    { id: 1, name: "启用" },
    { id: 0, name: "禁用" }
  ];
  productClassifyOptions = [];
  initProductClassifyList(e) {
    if (!e) return;
    this.getProductClassifyList("");
  }

  getProductClassifyList(str) {
    if (typeof str == "object") {
      str = "";
    }
    const params = {
      merchantId: this.merchantId,
      parentId: this.queryForm.productType,
      name: str
    }
    getProductClassifyList(params).then((res) => {
      this.productClassifyOptions = res.data.map((item) => ({ id: item.id, name: item.majorName }));
    })
  }

  productTypeChange(value) {
    if (!value) this.queryForm.productClassify = "";
  }

  searchHandle() {
    this.resetCurrent();
    this.getData();
  }

  rowKey = (row) => {
    return row.id;
  }

  setCurrentSelects(selection: any[]) {
    this.selectionList = selection.map((item) => item.id);
    this.batchDisabled = selection.length == 0;
  }

  batchEditDialogClose() {
    this.batchEditDialogVisible = false;
    this.queryForm = {
      merchantId: this.merchantId,
      productType: "",
      productClassify: "",
      status: "",
      name: "",
    };
    this.$emit("syncListData");
  }

  batchDisabling() {
    updateBatchStatus({ idList: this.selectionList, status: 0 }).then((res) => {
      this.getData();
      this.$message.success("操作成功");
      this.TableRef?.clearSelection();
    })
  }
  batchEnable() {
    updateBatchStatus({ idList: this.selectionList, status: 1 }).then((res) => {
      this.getData();
      this.$message.success("操作成功");
      this.TableRef?.clearSelection();
    })
  }

  getProductStatusDesc(status) {
    return status ? "启用" : "禁用";
  }

  @Watch('batchEditDialogVisible')
  getData() {
    if (!this.batchEditDialogVisible) return;
    getUpdateBatchPage({ ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then(res => {
      this.dataSource = res.data.list;
      this.itemTotal = res.data.total;
    })
  }
}

